import { render, staticRenderFns } from "./NewPasswordContent.vue?vue&type=template&id=60f79a7b&scoped=true&"
import script from "./NewPasswordContent.vue?vue&type=script&lang=js&"
export * from "./NewPasswordContent.vue?vue&type=script&lang=js&"
import style0 from "./NewPasswordContent.vue?vue&type=style&index=0&id=60f79a7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f79a7b",
  null
  
)

export default component.exports